// snow.js
(function() {
    var snowContainer = document.createElement('div');
    snowContainer.id = 'snow-container';
    document.body.appendChild(snowContainer);

    function createSnowflake() {
        var snowflake = document.createElement('div');
        snowflake.className = 'snowflake';
        snowflake.style.left = Math.random() * window.innerWidth + 'px';
        snowflake.style.animationDuration = 3 + Math.random() * 5 + 's';
        snowflake.style.opacity = 0.1 + Math.random() * 0.3; // lighter snow
        snowflake.style.fontSize = 5 + Math.random() * 20 + 'px'; // smaller snowflakes
        snowflake.innerHTML = '❄';
        snowContainer.appendChild(snowflake);

        setTimeout(function() {
            snowflake.remove();
        }, 8000);
    }

    // Create snowflake less frequently (every 300ms)
    setInterval(createSnowflake, 500);
})();
